import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { toast } from "react-toastify";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import {
  getRanked,
  toggleRankedActive,
  addRanked,
} from "../../../slices/3-ranked/thunk";
import RankedViewModal from "./RankedViewModal";
import CreateRankedModal from "./CreateRankedModal";

const ChampionshipsTable = () => {
  const [modal_list, setmodal_list] = useState(false);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [nameAR, setNameAR] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [index, setIndex] = useState("");
  const [typeFilter, setTypeFilter] = useState(" ");
  const [title, setTitle] = useState("");
  const [questionsCount, setQuestionsCount] = useState("");
  const [category1, setCategory1] = useState(null);
  const [category2, setCategory2] = useState(null);
  const [category3, setCategory3] = useState(null);

  const [selectedRanked, setSelectedRanked] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isActiveStatus, setIsActiveStatus] = useState(false);
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState("ri-folder-line");
  const [items, setItems] = useState([]);

  const [viewModal, setViewModal] = useState(false);
  const [selectedRankedView, setSelectedRankedView] = useState(null);

  const { ranked, loading, error, totalPages } = useSelector(
    (state) => state.Ranked,
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getRanked({ page, limit }));
  }, [dispatch, page]);

  const handleSubmit = (data) => {
    dispatch(addRanked(data))
      .unwrap()
      .then(() => {
        toast.success("تم الإنشاء");
        setmodal_list(false);
        dispatch(getRanked({ page, limit }));
      })
      .catch((err) => {
        toast.error(err?.message || "فشل الإنشاء");
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("هل انت متأكد من مسح المنتج؟")) {
      // dispatch(deleteCommodity(id));
    }
  };

  const tog_list = () => {
    setmodal_list(!modal_list);
  };

  document.title = "Championship";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm?.length >= 3 || searchTerm?.length === 0) {
        dispatch(getRanked({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, page, searchTerm]);

  useEffect(() => {
    setItems(ranked);
  }, [ranked]);

  const handleToggleActive = (item) => {
    dispatch(toggleRankedActive(item._id));
  };

  const openToggleModal = (item) => {
    setSelectedRanked(item);
    setIsActiveStatus(item.isActive);
    setDeleteModal(true);
  };

  const confirmToggleActive = () => {
    if (selectedRanked) {
      dispatch(toggleRankedActive(selectedRanked._id));
      setDeleteModal(false);
      setSelectedRanked(null);
    }
  };

  const openViewModal = (item) => {
    setSelectedRankedView(item);
    setViewModal(true);
  };

  // console.log(selectedUserId);
  // console.log(ranked);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة البطولات" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  <div className="listjs-table" id="tagsList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="بحث..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>

                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1 rounded-3"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            إضافة
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light text-center">
                          <tr>
                            <th>الاسم</th>
                            <th>عدد اللاعبين</th>
                            <th>عدد الاسئلة</th>
                            {/* <th>التصنيف الاول</th>
                            <th>التصنيف الثاني</th>
                            <th>التصنيف الثالث</th> */}
                            <th>الحالة</th>
                            <th>إجراءات</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all  text-center">
                          {ranked && ranked?.length > 0 ? (
                            ranked?.map((item, index) => (
                              <tr key={item.id} className="fs-5">
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {item._id}
                                  </Link>
                                </td>

                                <td className="name">{item.name}</td>
                                <td className="phone">{item.playersCounter}</td>
                                {/* <td className="category_1">
                                  {item.category_1?.name}
                                </td>
                                <td className="category_2">
                                  {item.category_2?.name}
                                </td>
                                <td className="category_3">
                                  {item.category_3?.name}
                                </td> */}
                                <td className="questionCount">
                                  {item.questionCount}
                                </td>
                                <td>
                                  <span
                                    className={`badge rounded-pill ${
                                      item.isActive ? "bg-success" : "bg-danger"
                                    }`}
                                  >
                                    {item.isActive ? "نشطة" : "غير نشط"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-3 justify-content-center">
                                    {/* Toggle */}
                                    <button
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openToggleModal(item)}
                                    >
                                      <i
                                        className={
                                          item.isActive
                                            ? "ri-toggle-fill"
                                            : "ri-toggle-line"
                                        }
                                        style={{
                                          color: item.isActive
                                            ? "green"
                                            : "gray",
                                          fontSize: "22px",
                                        }}
                                      ></i>
                                    </button>

                                    {/* View */}
                                    <button
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openViewModal(item)}
                                    >
                                      <i
                                        className="ri-eye-line"
                                        style={{
                                          fontSize: "20px",
                                          color: "#3498db",
                                        }}
                                      ></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                لا يوجد بطولات
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination */}
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6">
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(newPage) => {
                            setPage(newPage);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <CreateRankedModal
        isOpen={modal_list}
        toggle={tog_list}
        ranked={ranked}
        onSubmit={handleSubmit}
      />

      {/* Confirm Toggle Block Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الحالة
        </ModalHeader>

        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${
                isActiveStatus ? "text-danger" : "text-success"
              }`}
            ></i>

            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>

              <p className="text-muted mx-4 mb-0">
                هل تريد {isActiveStatus ? "إيقاف" : "تفعيل"} هذه البطولة؟
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>

            <Button
              color={isActiveStatus ? "danger" : "success"}
              onClick={confirmToggleActive}
            >
              نعم، {isActiveStatus ? "إيقاف" : "تفعيل"}
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <RankedViewModal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        data={selectedRankedView}
      />
    </React.Fragment>
  );
};

export default ChampionshipsTable;
